module.exports = __webpack_public_path__ + "images/bed-black.svg";